import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import RoleForm from "../components/Roles/RoleForm";
import RoleInfo from "../components/Roles/RoleInfo";
import RoleScopesList from "../components/Roles/RoleScopesList";
import TenantUserRolesGrid from "../components/Tenants/TenantUserRolesGrid";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import DetailTabsSection from "../components/ui/DetailTabsSection";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";
import {snackbar} from "../utils/snackbar";

const RoleDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewRole = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: `/roles`, resource: "roles"});

  const {list} = useApiRequest({baseUrl: `/roles/${id}/users`, resource: "roles", field: "users"});

  const [isEditing, setIsEditing] = useState(isNewRole);
  const {can} = useAuthPermissions();
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Rol eliminado correctamente.");
    navigate("/roles");
  });

  useEffect(() => {
    if (!isNewRole) {
      (async () => {
        const {success} = await read(id);
        if (!success) return;
        await list();
      })();
    }
    // eslint-disable-next-line
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <>
      <Window title={isNewRole ? "Nuevo Rol" : "Detalles del Rol"} backTo="/roles">
        {loading && !isNewRole ? (
          <CircularProgress />
        ) : (
          <>
            <Stack direction="row" spacing={2} justifyContent={"space-between"}>
              {isEditing ? (
                <RoleForm
                  isNew={isNewRole}
                  refreshData={() => read(id)}
                  setIsEditing={setIsEditing}
                  initialRoleData={data || {}}
                />
              ) : (
                <RoleInfo role={data} />
              )}
              <Box>
                {!isNewRole &&
                  (can(ACTIONS.WRITE, RESOURCES.ROLES) && (
                    isEditing ? (
                      <Button variant="contained" color="primary" onClick={handleEditToggle}>
                        Cancelar
                      </Button>
                    ) : (
                      <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                        <FiEdit2 />
                      </IconButton>
                    )
                  ))}
                {!isNewRole && can(ACTIONS.DELETE, RESOURCES.ROLES) && (
                  <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                    <FiTrash2 />
                  </IconButton>
                )}
              </Box>
            </Stack>

            {!isNewRole && (
              <DetailTabsSection
                tabs={[
                  {
                    label: "Scopes",
                    content: <RoleScopesList roleId={id} />
                  },
                  {
                    label: "Tenants y Usuarios",
                    content: <TenantUserRolesGrid roleId={id} canAssign={false} canDelete={false} />
                  }
                ]}
              />
            )}
          </>
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="rol"
        entityLabel={itemName}
      />
    </>
  );
};

export default RoleDetail;
